<template>
    <span :class="['quiz-result-item', { 'correct': result.isCorrect }, { 'incorrect': !result.isCorrect }]">
        <span class="quiz-result-item__number">{{ index + 1 }}.</span>
        <span v-html="result.question"></span>
        <span :class="result.isCorrect ?  'icon-checked' : 'icon-clear'"></span>
    </span>
</template>

<script>
    export default {
        name: 'quiz-result-item',
        props: {
            result: Object,
            index: Number
        }

    }
</script>

<style lang="scss" scoped>
    .quiz-result-item {
        font-family: PlusJakartaSans-Medium, sans-serif;
        font-size: 1.6rem;
        color: $tuatara;
        line-height: 150%;
        padding: 16px 20px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        gap: 20px;

        &.correct {
            background: rgba(60, 110, 113, 0.10);
        }

        &.incorrect {
            background: rgba(183, 69, 69, 0.10);
        }

        &__number {
            font-size: 2.4rem;
        }

        [class*=icon-] {
            font-size: 3rem;
            margin: 0 0 0 auto;
        }

        .icon-checked {
            color: $william;
        }

        .icon-clear {
            color: $valencia;
        }
    }
</style>
